import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_w5tmkmaxbm: FaireBrandEntity = {
  token: "b_w5tmkmaxbm",
  type: "brand",
  name: "SAUCE UP NEW YORK",
  avatarUrl:
    "https://cdn.faire.com/fastly/1891b67a9641460b9bc56c56766086b5e79e64c2f7ca233dac24d18a539f1ed4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/09a659c973988681182f74ee6f0fb80db245b29ec5552862ecca856f754a9e5a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1891b67a9641460b9bc56c56766086b5e79e64c2f7ca233dac24d18a539f1ed4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/09a659c973988681182f74ee6f0fb80db245b29ec5552862ecca856f754a9e5a.jpeg",
  location: "Glen Cove, NY, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "About Us\n\nSauce Up New York was created to bring restaurant-grade flavor into everyday kitchens. Founded by Chef David, whose background spans Michelin-starred restaurants like Gordon Ramsay, Eleven Madison Park, and top NYC establishments, our mission is simple: help people eat better, flavor up, and feel happier.\n\nEvery jar is handcrafted in small batches in our New York facility using 100% natural, plant-powered, gluten-free, and non-GMO ingredients. We pack each sauce with superfoods and bold, clean flavors—no additives, no preservatives, no shortcuts. Just premium ingredients and chef-level technique.\n\nFrom our iconic Garlic Chip Chili Sauce to our vibrant Chimi Green and nut crunch creations, our sauces are designed to be ultra-versatile, uplifting anything you drizzle, dip, or cook with. Whether you’re a busy home cook or a food lover who wants more joy on the plate, we’re here to make every meal feel elevated, effortless, and delicious.\n\nAt Sauce Up NYC, we believe food should make you feel good—inside and out. Welcome to better flavor, made with love in New York.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:57.688Z",
    importedBy: "entity-db-cli",
  },
};
